import { forwardRef, type SelectHTMLAttributes } from 'react';
import styles from './Input.module.css';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  hint?: string;
  error?: string | null;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, hint, error, options, placeholder, id, className = '', ...rest },
  ref,
) {
  const selId = id ?? rest.name ?? `sel_${Math.random().toString(36).slice(2, 9)}`;
  return (
    <label className={styles.wrap} htmlFor={selId}>
      {label && <span className={styles.label}>{label}</span>}
      <span className={`${styles.field} ${error ? styles.fieldError : ''}`}>
        <select
          ref={ref}
          id={selId}
          className={`${styles.input} ${className}`}
          aria-invalid={!!error}
          {...rest}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </span>
      {error ? (
        <span className={styles.error}>{error}</span>
      ) : hint ? (
        <span className={styles.hint}>{hint}</span>
      ) : null}
    </label>
  );
});
